<div appFileDragAndDrop class="container" (fileDropped)="processFile($event)">
    <mat-icon class="material-icons-outlined image"> cloud_upload </mat-icon>
    <div class="text">
        <p>Drag and drop your file here</p>
        <p>or</p>
    </div>
    <button mat-button primaryButton (click)="openDialog(fileInput)">Browse</button>
</div>
<div class="file-container">
    <div class="file" *ngIf="file">
        <mat-icon class="material-icons-outlined">description</mat-icon>
        <span>{{ file.name }}</span>
    </div>
</div>

<input #fileInput hidden type="file" (change)="fileSelected(fileInput)" />
